$(function(){
    
    /*------------------------------------*\
        topスライダーの文字を省略
        数値は暫定
    \*------------------------------------*/
    
    // //topスライダーの記事タイトルを省略
    // $(".hero_slider_inner h2").each(function(){
    //     if ($(this).text().length > 24) {
    //         $(this).text($(this).text().substr(0, 23)).append('…') 
    //     }
    // })
    // 
    // //topスライダーのリード文を省略
    // $(".hero_slider_inner p").each(function(){
    //     if ($(this).text().length > 90) {
    //         $(this).text($(this).text().substr(0, 89)).append('…') 
    //     }
    // })
    
    //作品タイトルを2行(約38文字に制限)
    $(".art_info_title").each(function(){
        if ($(this).text().length > 38) {
            $(this).text($(this).text().substr(0, 37)).append('…') 
        }
    })
    $(".overlay_info h3").each(function(){
        if ($(this).text().length > 38) {
            $(this).text($(this).text().substr(0, 37)).append('…') 
        }
    })
  
  
})